import { Navigate, Route, Routes } from 'react-router-dom'
import { lazy, Suspense, type ReactNode } from 'react'

import { AppShell } from '../components/layout/AppShell'
import type { AccessGateway } from '../domain/access'
import { AgendaPage } from '../features/agenda/AgendaPage'
import { TodayPage } from '../features/today/TodayPage'

const MapPage = lazy(async () => ({ default: (await import('../features/map/MapPage')).MapPage }))
const GroupPage = lazy(async () => ({ default: (await import('../features/group/GroupPage')).GroupPage }))
const AlbumPage = lazy(async () => ({ default: (await import('../features/album/AlbumPage')).AlbumPage }))
const PracticalPage = lazy(async () => ({ default: (await import('../features/practical/PracticalPage')).PracticalPage }))

function LazyRoute({ children }: { children: ReactNode }) {
  return <Suspense fallback={<p className="route-loading">Ouverture du carnet…</p>}>{children}</Suspense>
}

export function AppRouter({ gateway }: { gateway: AccessGateway }) {
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<TodayPage />} />
        <Route path="agenda" element={<AgendaPage />} />
        <Route path="carte" element={<LazyRoute><MapPage /></LazyRoute>} />
        <Route path="groupe" element={<LazyRoute><GroupPage gateway={gateway} /></LazyRoute>} />
        <Route path="souvenirs" element={<LazyRoute><AlbumPage /></LazyRoute>} />
        <Route path="pratique" element={<LazyRoute><PracticalPage /></LazyRoute>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
